import {
  ICreateCompanyReq,
  ICompany,
  IUpdateGoogleAds
} from "../../models/company/index";
import {
  IBasePagingRes,
  IBaseResponseModel
} from "../../models/common/models.type";
import api from "../remote/baseApi";
import ApiEndpoints from "../remote/apiEndpoints";
import { envConfig } from "../../config/env.config";
import {
  IConversationReq,
  ICreateConversationReq,
  IGetPageConversationReq,
  IMarkAsReadReq,
  IMessagesRs,
  IPageConversationRs,
  IUpdateGroupTitleReq
} from "../../models/conversation";

const API = ApiEndpoints.CHAT;
const baseURL = envConfig.CHAT_ENDPOINT;

const getPageConversationsByUser = (
  data: IGetPageConversationReq
): Promise<IBasePagingRes<IPageConversationRs>> => {
  return api.get(baseURL, API.GET_PAGE_CONVERSATION.url, {
    params: data
  });
};

const getPageMessages = (
  data: IGetPageConversationReq
): Promise<IBasePagingRes<IMessagesRs>> => {
  return api.get(baseURL, API.GET_PAGE_MESSAGES.url, {
    params: data
  });
};

const create = async (
  data: ICreateConversationReq
): Promise<IConversationReq> => {
  const res = await api.post<ICreateConversationReq, IConversationReq>(
    baseURL,
    API.CREATECONVERSATION.url,
    data
  );

  return res;
};

const updateGroupTitleAsync = async (
  data: IUpdateGroupTitleReq
): Promise<IBaseResponseModel<any>> => {
  return await api.put<IUpdateGroupTitleReq, IBaseResponseModel<any>>(
    baseURL,
    API.UPDATE_GROUP_TITLE.url,
    data
  );
};

const markAsRead = async (
  data: IMarkAsReadReq
): Promise<IBaseResponseModel<any>> => {
  return await api.put<IMarkAsReadReq, IBaseResponseModel<any>>(
    baseURL,
    API.Mark_As_Read.url,
    data
  );
};

const getOnlineUsersRelatedToUserAsync = async (): Promise<
  IBaseResponseModel<any>
> => {
  return await api.get<IBaseResponseModel<any>>(
    baseURL,
    API.Get_Online_Users_Related_To_User.url
  );
};

const ConversationService = {
  getPageConversationsByUser,
  getPageMessages,
  create,
  updateGroupTitleAsync,
  getOnlineUsersRelatedToUserAsync,
  markAsRead
};

export default ConversationService;
